var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.19284C1.89543 1.19284 1 2.26094 1 3.5785V33.3993C1 34.7169 1.89543 35.7849 3 35.7849H37C38.1046 35.7849 39 34.7169 39 33.3993V3.5785C39 2.26094 38.1046 1.19284 37 1.19284H3ZM36 10.7355H4V33.3993H36V10.7355Z",
    fill: "url(#paint0_linear_300_756)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6172 0.447327H2.38281C1.06903 0.447327 0 1.7225 0 3.28962V34.881C0 36.4481 1.06903 37.7233 2.38281 37.7233H37.6172C38.931 37.7233 40 36.4481 40 34.881V3.28962C40 1.7225 38.931 0.447327 37.6172 0.447327ZM38.4375 34.881C38.4375 35.4205 38.0695 35.8595 37.6172 35.8595H2.38281C1.93054 35.8595 1.5625 35.4205 1.5625 34.881V3.28962C1.5625 2.75013 1.93054 2.31112 2.38281 2.31112H37.6172C38.0695 2.31112 38.4375 2.75013 38.4375 3.28962V34.881Z",
    fill: "url(#paint1_linear_300_756)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 6.90835H35.0781C35.5096 6.90835 35.8594 6.49118 35.8594 5.97645C35.8594 5.46209 35.5096 5.04456 35.0781 5.04456H14.9219C14.4904 5.04456 14.1406 5.46209 14.1406 5.97645C14.1406 6.49118 14.4904 6.90835 14.9219 6.90835Z",
    fill: "url(#paint2_linear_300_756)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99207 6.33323C4.0116 6.38929 4.03571 6.44317 4.06379 6.4934C4.09186 6.54473 4.12482 6.59242 4.16083 6.635C4.3061 6.80937 4.50751 6.90838 4.71289 6.90838C4.76447 6.90838 4.81543 6.90256 4.86609 6.89055C4.91614 6.87854 4.96528 6.86069 5.01227 6.8374C5.05927 6.8141 5.10444 6.78534 5.14655 6.75185C5.18958 6.71727 5.22956 6.67795 5.26526 6.63537C5.30219 6.59242 5.33423 6.54473 5.36292 6.49376C5.3913 6.44317 5.41541 6.38929 5.43494 6.33323C5.45447 6.27645 5.46943 6.21783 5.4795 6.15886C5.48957 6.09843 5.49414 6.03691 5.49414 5.97649C5.49414 5.9157 5.48957 5.85417 5.4795 5.79484C5.46943 5.73514 5.45447 5.67617 5.43494 5.62047C5.41541 5.56368 5.3913 5.50944 5.36292 5.45921C5.33423 5.40789 5.30219 5.36056 5.26526 5.3176C5.22956 5.27465 5.18958 5.2357 5.14655 5.20185C5.10444 5.16835 5.05927 5.1396 5.01227 5.1163C4.96528 5.093 4.91614 5.07516 4.86609 5.06315C4.76539 5.03877 4.66163 5.03877 4.56061 5.06315C4.51056 5.07516 4.46143 5.093 4.41474 5.1163C4.36683 5.1396 4.32166 5.16835 4.27955 5.20185C4.23652 5.2357 4.19654 5.27465 4.16083 5.3176C4.12482 5.36056 4.09186 5.40789 4.06379 5.45921C4.03571 5.50944 4.0116 5.56368 3.99207 5.62047C3.97254 5.67617 3.95758 5.73514 3.94751 5.79484C3.93714 5.85417 3.93164 5.9157 3.93164 5.97649C3.93164 6.03691 3.93714 6.09843 3.94751 6.15886C3.95758 6.21783 3.97254 6.27645 3.99207 6.33323Z",
    fill: "url(#paint3_linear_300_756)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11707 6.33323C7.1366 6.38929 7.16071 6.44317 7.18879 6.4934C7.21686 6.54473 7.24982 6.59242 7.28583 6.635C7.4311 6.80937 7.63251 6.90838 7.83789 6.90838C7.88947 6.90838 7.94043 6.90256 7.99109 6.89055C8.04114 6.87854 8.09028 6.86069 8.13727 6.8374C8.18427 6.8141 8.22944 6.78534 8.27155 6.75185C8.31458 6.71727 8.35456 6.67795 8.39118 6.63537C8.42719 6.59242 8.45923 6.54473 8.48792 6.49376C8.5163 6.44317 8.54041 6.38929 8.55994 6.33323C8.57947 6.27645 8.59443 6.21783 8.6045 6.15886C8.61457 6.09843 8.61914 6.03691 8.61914 5.97649C8.61914 5.9157 8.61457 5.85417 8.6045 5.79484C8.59443 5.73514 8.57947 5.67617 8.55994 5.62047C8.54041 5.56368 8.5163 5.50944 8.48792 5.45921C8.45923 5.40789 8.42719 5.36056 8.39118 5.3176C8.35456 5.27465 8.31458 5.2357 8.27155 5.20185C8.22944 5.16835 8.18427 5.1396 8.13727 5.1163C8.09028 5.093 8.04114 5.07516 7.99109 5.06315C7.89039 5.03877 7.78663 5.03877 7.68561 5.06315C7.63556 5.07516 7.58643 5.093 7.53974 5.1163C7.49183 5.1396 7.44666 5.16835 7.40455 5.20185C7.36152 5.2357 7.32154 5.27465 7.28583 5.3176C7.24982 5.36056 7.21686 5.40789 7.18879 5.45921C7.16071 5.50944 7.1366 5.56368 7.11707 5.62047C7.09754 5.67617 7.08258 5.73514 7.07251 5.79484C7.06214 5.85417 7.05664 5.9157 7.05664 5.97649C7.05664 6.03691 7.06214 6.09843 7.07251 6.15886C7.08258 6.21783 7.09754 6.27645 7.11707 6.33323Z",
    fill: "url(#paint4_linear_300_756)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2425 6.33323C10.262 6.38929 10.2861 6.44317 10.3142 6.4934C10.3423 6.54473 10.3753 6.59241 10.4113 6.635C10.447 6.67795 10.487 6.71727 10.53 6.75149C10.5721 6.78534 10.6173 6.8141 10.6652 6.8374C10.7119 6.86069 10.761 6.87854 10.8111 6.89055C10.8611 6.90256 10.9127 6.90803 10.9633 6.90803C11.0149 6.90803 11.0659 6.90256 11.1165 6.89055C11.1666 6.87854 11.2157 6.86069 11.2627 6.8374C11.3097 6.8141 11.3549 6.78534 11.3979 6.75149C11.44 6.71727 11.48 6.67795 11.5166 6.635C11.5526 6.59241 11.5847 6.54473 11.6134 6.4934C11.6417 6.44317 11.6658 6.38929 11.6854 6.33323C11.7049 6.27645 11.7199 6.21783 11.7299 6.15886C11.74 6.09843 11.7446 6.03691 11.7446 5.97613C11.7446 5.9157 11.74 5.85417 11.7299 5.79447C11.7199 5.73477 11.7049 5.67617 11.6854 5.62047C11.6658 5.56332 11.6417 5.50944 11.6134 5.45921C11.5847 5.40789 11.5526 5.3602 11.5166 5.3176C11.48 5.27465 11.44 5.23533 11.3979 5.20185C11.3549 5.16835 11.3097 5.1396 11.2627 5.1163C11.2157 5.093 11.1666 5.07516 11.1165 5.06315C11.0158 5.03877 10.9121 5.03877 10.8111 5.06315C10.761 5.07516 10.7119 5.093 10.6652 5.1163C10.6173 5.1396 10.5721 5.16835 10.53 5.20185C10.487 5.23533 10.447 5.27465 10.4113 5.3176C10.3753 5.3602 10.3423 5.40789 10.3142 5.45921C10.2861 5.50944 10.262 5.56332 10.2425 5.62047C10.223 5.67617 10.208 5.73477 10.198 5.79447C10.1876 5.85417 10.1821 5.9157 10.1821 5.97613C10.1821 6.03691 10.1876 6.09843 10.198 6.15886C10.208 6.21783 10.223 6.27645 10.2425 6.33323Z",
    fill: "url(#paint5_linear_300_756)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7154 16.3883C22.344 16.1261 21.8649 16.2732 21.6452 16.7162L17.0099 26.0662C16.7901 26.5092 16.9131 27.0807 17.2845 27.3424C17.4093 27.4306 17.5464 27.4728 17.6816 27.4728C17.9486 27.4728 18.2089 27.3089 18.3548 27.0149L22.9901 17.6649C23.2098 17.2219 23.0868 16.6504 22.7154 16.3883Z",
    fill: "url(#paint6_linear_300_756)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9768 19.1272V18.1861C12.9768 17.6652 13.332 17.2412 13.7687 17.2412H13.7797C14.2112 17.2412 14.5609 16.8239 14.5609 16.3092C14.5609 15.7949 14.2112 15.3774 13.7797 15.3774H13.7687C12.4705 15.3774 11.4143 16.6376 11.4143 18.1861V19.1272C11.4143 19.466 11.2977 19.7966 11.0945 20.0336L10.0822 21.2149C9.93293 21.3889 9.8484 21.6269 9.84718 21.8759C9.84626 22.1249 9.92866 22.364 10.0764 22.5402L11.1079 23.7703C11.3069 24.0073 11.4173 24.3225 11.4195 24.6581L11.425 25.6348C11.4341 27.1728 12.4903 28.4243 13.7797 28.4243C14.2112 28.4243 14.5609 28.0067 14.5609 27.4924C14.5609 26.9777 14.2112 26.5605 13.7797 26.5605C13.3457 26.5605 12.9905 26.1393 12.9875 25.622L12.982 24.6454C12.9771 23.8165 12.7036 23.0375 12.2126 22.4522L11.7396 21.8883L12.1873 21.3659C12.689 20.7802 12.9768 19.9644 12.9768 19.1272Z",
    fill: "url(#paint7_linear_300_756)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0232 24.6745V25.6155C27.0232 26.1365 26.668 26.5605 26.2313 26.5605H26.2203C25.7888 26.5605 25.439 26.9777 25.439 27.4924C25.439 28.0067 25.7888 28.4243 26.2203 28.4243H26.2313C27.5295 28.4243 28.5857 27.1641 28.5857 25.6155V24.6745C28.5857 24.3357 28.7023 24.0051 28.9055 23.7681L29.9178 22.5869C30.067 22.4128 30.1516 22.1747 30.1525 21.9258C30.1537 21.6767 30.0713 21.4376 29.9236 21.2614L28.8921 20.0315C28.6931 19.7944 28.5823 19.4788 28.5805 19.1435L28.5747 18.1668C28.5659 16.6289 27.5097 15.3777 26.2203 15.3777C25.7888 15.3777 25.439 15.7949 25.439 16.3096C25.439 16.8239 25.7888 17.2415 26.2203 17.2415C26.6539 17.2415 27.0095 17.6624 27.0122 18.1796L27.018 19.1563C27.0229 19.9848 27.296 20.7639 27.7874 21.3495L28.2604 21.9134L27.8127 22.4357C27.311 23.0212 27.0232 23.8373 27.0232 24.6745Z",
    fill: "url(#paint8_linear_300_756)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0442 9.70404H3.95557C3.52405 9.70404 3.17432 10.1216 3.17432 10.6359V33.0016C3.17432 33.5163 3.52405 33.9334 3.95557 33.9334H13.2552C13.6867 33.9334 14.0365 33.5163 14.0365 33.0016C14.0365 32.4872 13.6867 32.0696 13.2552 32.0696H4.73682V11.5678H35.263V32.0696H19.5311C19.0996 32.0696 18.7499 32.4872 18.7499 33.0016C18.7499 33.5163 19.0996 33.9334 19.5311 33.9334H36.0442C36.4757 33.9334 36.8255 33.5163 36.8255 33.0016V10.6359C36.8255 10.1216 36.4757 9.70404 36.0442 9.70404Z",
    fill: "url(#paint9_linear_300_756)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_756",
    x1: 3.15333,
    y1: 1.19284,
    x2: 32.6137,
    y2: 36.9292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_756",
    x1: 2.26667,
    y1: 0.447327,
    x2: 34.1465,
    y2: 38.2231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_756",
    x1: 15.3714,
    y1: 5.04456,
    x2: 15.6211,
    y2: 8.25915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_300_756",
    x1: 4.02019,
    y1: 5.04486,
    x2: 5.63217,
    y2: 6.53734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_300_756",
    x1: 7.14519,
    y1: 5.04486,
    x2: 8.75717,
    y2: 6.53734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_300_756",
    x1: 10.2706,
    y1: 5.04486,
    x2: 11.8824,
    y2: 6.53735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_300_756",
    x1: 17.2521,
    y1: 16.2584,
    x2: 25.9051,
    y2: 21.5394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_300_756",
    x1: 10.1143,
    y1: 15.3774,
    x2: 17.9059,
    y2: 18.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_300_756",
    x1: 25.7061,
    y1: 15.3777,
    x2: 33.4973,
    y2: 18.4859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_300_756",
    x1: 5.08121,
    y1: 9.70405,
    x2: 24.3163,
    y2: 39.2039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdev);
export default __webpack_public_path__ + "static/media/webdev.7686506d03b98f0503acad03231a02a7.svg";
export { ForwardRef as ReactComponent };